import styles from './style.module.css';
import { SketchPicker } from 'react-color';
import { useEffect, useState } from 'react';

function AppColourPicker({ defaultHex, onChange }) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [colour, setColour] = useState('#000000');

  useEffect(() => {
    if (defaultHex) setColour(defaultHex);
  }, [defaultHex]);

  function handleClick() {
    setDisplayColorPicker(!displayColorPicker);
  }

  function handleChange(color) {
    setColour(color.hex);
    onChange(color.hex, color);
  }

  function handleClose() {
    setDisplayColorPicker(false);
  }

  return (
    <div>
      <div className={styles.swatch} onClick={handleClick}>
        <div className={styles.color} style={{ width: '100px', background: colour }} />
      </div>
      {displayColorPicker ? (
        <div className={styles.popover}>
          <div className={styles.cover} onClick={handleClose} />
          <SketchPicker color={colour} onChange={handleChange} />
        </div>
      ) : null}
    </div>
  );
}

AppColourPicker.defaultProps = {
  onChange: () => {},
};

export default AppColourPicker;
